<template>
    <section class="offer-slider">
        <DefaultOfferSlider
            :slides="filteredSlidesData"
            :additional-settings="additionalSettings"
        >
            <template #slide="{slide}">
                <SlideItem v-bind="slide" />
            </template>
        </DefaultOfferSlider>
    </section>
</template>

<script>
import {defineComponent, computed} from 'vue';
import SlideItem from '@/components/Sliders/OfferSlider/SlideItem.vue';
import DefaultOfferSlider from '@/components/Sliders/OfferSlider/DefaultOfferSlider.vue';
import {useRegionsStore} from '@/stores/regions';

export default defineComponent({
    name: 'OfferSlider',
    components: {
        SlideItem,
        DefaultOfferSlider,
    },
    props: {
        slidesData: {
            type: Array,
            required: true,
        },
        additionalSettings: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const regionsStore = useRegionsStore();
        const userRegion = computed(() => regionsStore.userRegion);

        const filteredSlidesData = computed(() => {
            return props.slidesData.filter((slideData) => {
                if (slideData.modifyOptions?.regions?.length) {
                    return userRegion.value ? slideData.modifyOptions?.regions.includes(userRegion.value.id) : false;
                }

                return slideData;
            });
        });

        return {
            filteredSlidesData,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/sections/sliders/offer-slider';
</style>
